<script>
import fuzzysort from 'fuzzysort'

export default {
    props: {
        group: { type: Object, required: true },
        allGroups: { type: Array, required: true },
        showSearch: { type: Boolean },
        selectedCategories: { type: Array },
        searchStr: { type: String },
        resultsStyle: { type: String },
    },

    data() {
        return {
            searchStatus: 0,
            people: this.group.people,
        }
    },

    watch: {
        searchStr() {
            this.applySearch()
        },
        selectedCategories() {
            this.applySearch()
        },
    },

    methods: {
        applySearch() {
            // Just in case search takes considerable time on low-end devices
            // Debounce it using primitive searchStatus flag
            if (this.searchStatus) {
                this.searchStatus = 2
                return
            }

            const oneMoreTime = this.searchStatus === 2
            this.searchStatus = 1

            if (this.searchStr) {
                // Filter by user input
                const results = fuzzysort.go(this.searchStr, this.group.people, {
                    keys: ['name', 'job'],
                    threshold: -10000,
                })
                this.people = results.map(r => {
                    return Object.assign({}, r.obj, {
                        nameHighlighted: r[0] && fuzzysort.highlight(r[0], '<b>', '</b>'),
                        jobHighlighted: r[1] && fuzzysort.highlight(r[1], '<b>', '</b>'),
                    })
                })
            } else {
                this.people = this.group.people
            }

            if (this.selectedCategories.length) {
                // Filter by category selection
                this.people = this.people.filter(p => {
                    return this.selectedCategories.some(catId => p.cat.includes(catId))
                })
            }

            this.searchStatus = 0
            if (oneMoreTime) {
                this.applySearch()
            }
        }
    }
}
</script>

<template>
    <div class="fpolit-group">
        <div v-if="showSearch || allGroups.length > 1" class="fpolit-ctrlCount">
            <span v-if="people.length > 1">{{ people.length }} personer</span>
            <span v-else-if="people.length === 1">1 person</span>
            <span v-else>Ingen</span>
            <span> hittades</span>
            <span v-if="allGroups.length > 1"> på {{ group.label }}</span>
        </div>

        <div class="container">
            <div class="fpolit-results" :class="{[`style--${resultsStyle}`]: resultsStyle, [`n-${people.length}x`]: true}">
                <article class="fpolit-person" v-for="person in people" :key="person.id">
                    <a :href="person.url || `/?p=${person.id}`">
                        <div class="fpolit-personImg">
                            <img v-if="person.img" :src="person.img" :alt="person.name"/>
                            <div v-else>
                                <span class="icon icon-head"/>
                            </div>
                        </div>
                        <div class="fpolit-personInfo">
                            <h2 v-html="person.nameHighlighted || person.name"></h2>
                            <p v-html="person.jobHighlighted || person.job"></p>
                        </div>
                    </a>
                </article>
            </div>
        </div>
    </div>
</template>
